import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import type { ExUsDetailsResponse, ExUsAlignmentResponse } from '../types/api/generated';
import { ExUsDetailsResponseSchema, ExUsAlignmentResponseSchema } from '../types/api/schemas';
import { validateResponse } from './validateResponse';

export const exusApi = createApi({
    reducerPath: 'exusApi',
    baseQuery,
    endpoints: (builder) => ({
        exusDetails: builder.mutation<ExUsDetailsResponse, unknown>({
            query: (body) => ({ url: 'api/v2/exus/details', method: 'POST', body }),
            transformResponse: validateResponse(ExUsDetailsResponseSchema),
        }),
        exusAlignment: builder.mutation<ExUsAlignmentResponse, unknown>({
            query: (body) => ({ url: 'api/v2/exus/alignment', method: 'POST', body }),
            transformResponse: validateResponse(ExUsAlignmentResponseSchema),
        }),
    }),
});

export const {
    useExusDetailsMutation,
    useExusAlignmentMutation,
} = exusApi;
